module.exports = __webpack_public_path__ + "static/media/marks-card-bg.31cef0ef.png";